// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2PdMN","detailsBorder":"styles_detailsBorder__2gN4q"};